import React, { useMemo, useState } from 'react';

import { StepContext } from './stepContext';

interface StepContextProviderProps {
  children: React.ReactNode;
}
export const StepContextProvider = ({ children }: StepContextProviderProps): React.JSX.Element => {
  const [step, setStep] = useState(0);
  const value = useMemo(() => ({ step, setStep }), [step]);
  return <StepContext.Provider value={value}>{children}</StepContext.Provider>;
};
